import React from 'react';
import { useFormikContext } from 'formik';

import MapPicker from '@components/form/MapPicker';

// eslint-disable-next-line react/prop-types
function SociollaMapPicker({ name, onChange, ...otherProps }) {
  const { setFieldValue, values } = useFormikContext();

  return (
    <MapPicker
      onChange={async (value) => {
        await setFieldValue(name, value);
        if (onChange) {
          onChange(value);
        }
      }}
      value={values[name]}
      {...otherProps}
    />
  );
}

export default SociollaMapPicker;
